import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { praxisPoolApi } from "@/lib/api";

// Zeigt CRM-weit in der Kopfzeile ein klickbares Badge, wenn ein Enrich-Lauf
// im Hintergrund läuft. Klick springt zur betroffenen Fachrichtung.
export const GlobalEnrichBadge = () => {
  const [job, setJob] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const timer = useRef(null);

  useEffect(() => {
    let active = true;
    const poll = async () => {
      try {
        const { data } = await praxisPoolApi.getActiveJob();
        if (active) setJob(data?.active || null);
      } catch {
        if (active) setJob(null);
      }
    };
    poll();
    timer.current = setInterval(poll, 6000);
    return () => { active = false; clearInterval(timer.current); };
  }, []);

  // Auf der Praxissuche selbst gibt es bereits das In-Page-Badge/den Dialog.
  if (!job || location.pathname.startsWith("/praxissuche")) return null;

  const total = job.total || 0;
  const done = job.done || 0;
  return (
    <button
      type="button"
      data-testid="global-enrich-badge"
      onClick={() => navigate(`/praxissuche?specialty=${encodeURIComponent(job.specialty_key)}`)}
      title="Anreicherung läuft im Hintergrund – klicken zum Anzeigen"
      className="hidden md:flex items-center gap-2 rounded-full border border-violet-200 dark:border-violet-900 bg-violet-50 dark:bg-violet-950/30 px-3 py-1.5 text-xs font-medium text-violet-800 dark:text-violet-200 transition-colors hover:bg-violet-100 dark:hover:bg-violet-950/50 max-w-[260px]"
    >
      <Loader2 className="w-3.5 h-3.5 shrink-0 animate-spin" />
      <span className="truncate">
        Anreicherung{job.specialty_name ? ` · ${job.specialty_name}` : ""}{total ? ` · ${done}/${total}` : "…"}
      </span>
    </button>
  );
};
